import { render, staticRenderFns } from "./PrimaCardList.vue?vue&type=template&id=d1423e48"
import script from "./PrimaCardList.vue?vue&type=script&lang=js"
export * from "./PrimaCardList.vue?vue&type=script&lang=js"
import style0 from "./PrimaCardList.vue?vue&type=style&index=0&id=d1423e48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports